import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import { Toaster } from "react-hot-toast";
import RequireAuth from "./contexts/RequireAuth";
import Layout from "./layout";
import Dashboard from "./pages/Dashboard/dashboard";
import Customers from "./pages/Dashboard/customers";
import Schemes from "./pages/Dashboard/schemes";
import Reports from "./pages/Dashboard/reports";
import Users from "./pages/Dashboard/users";
import Maps from "./pages/Dashboard/maps";
import Trash from "./pages/Dashboard/trash";
import CustomerList from "./pages/Dashboard/mobviewcust";
import Areas from "./pages/Dashboard/area";
import PaymentList from "./pages/Dashboard/mobviewpayments";
import Assets from "./pages/Dashboard/assetManagement/assets";
import MobViewAssets from "./pages/Dashboard/assetManagement/mobviewassets";

const App = () => {
  return (
    <>
      <Suspense
        fallback={
          <p style={{ fontSize: "23px", textAlign: "center" }}>
            Loading user details...
          </p>
        }
      >
        <Routes>
          <Route index element={<Login />} />

          {/* <Route path="/login" element={<Login />} /> */}
          {/* <Route element={<RequireAuth allowedRoles={["client", "admin"]} />}> */}
          {/* </Route> */}
          <Route element={<RequireAuth allowedRoles={["admin", "employee"]} />}>
            <Route path="dashboard" element={<Layout />}>
              {/* <Route index element={<Dashboard />} /> */}
              <Route path="customers" element={<Customers />} />
              <Route path="schemes" element={<Schemes />} />
              <Route path="assets" element={<Assets />} />
              <Route path="reports" element={<Reports />} />
              <Route path="users" element={<Users />} />
              <Route path="area" element={<Areas />} />
              <Route path="trash" element={<Trash />} />
            </Route>
          </Route>
          <Route element={<RequireAuth allowedRoles={["admin", "agent"]} />}>
            <Route path="dashboard" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="maps" element={<Maps />} />
              <Route path="list" element={<CustomerList />} />
              <Route path="assetlist" element={<MobViewAssets />} />

              <Route path="paymentslist" element={<PaymentList />} />
            </Route>
          </Route>
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
        <Toaster position="top-right" />
      </Suspense>
    </>
  );
};

export default App;
